<template>
  <page>
    <div class="home-warp">
      <div class="home-head">
        <img class="home-head-avatar" v-if="user && user.avatarUrl" :src="user.avatarUrl" alt="" @click="goRouter('/profile')">
        <img class="home-head-avatar" v-else src="@/assets/imgs/avatar.png" alt="">
        <div class="home-head-body">
          <div v-if="user && user.pname" @click="goRouter('/profile')">{{ user.pname }}</div>
          <div v-else @click="goRouter('/login')">{{ i18n.logout }}</div>
          <div v-if="user && user.pname" class="home-head-edit" @click="goRouter('/profile')">{{ i18n.edit_profile }}</div>
        </div>
        <div class="home-head-btn" @click="goRouter('/home_map')">
          <img src="@/assets/imgs/icon_switch.png" alt="">
        </div>
      </div>
      <div class="home-search" @click="goRouter('/shop')">
        <img src="@/assets/imgs/icons_search.png" alt="">
        <span>{{ i18n.search }}</span>
      </div>
      <div class="home-invite">
        <img class="home-invite-bg" src="@/assets/imgs/invite_card.png" alt="">
        <div class="home-invite-body">
          <div>{{ i18n.invite_text }}</div>
          <div class="home-invite-btn" @click="isInvite = true">
            <span>{{ i18n.invite_btn }}</span>
            <img src="@/assets/imgs/icon_home_more.png" alt="">
          </div>
        </div>
      </div>
      <div class="home-cards">
        <div class="home-card" @click="goRouter('/home_map')">
          <div class="home-card-icon">
            <img src="@/assets/imgs/icon_map.png" alt="">
          </div>
          <div class="home-card-title">{{ i18n.map }}</div>
          <div>{{ i18n.map_text }}</div>
          <img class="home-card-link" src="@/assets/imgs/icon_link.png" alt="">
        </div>
        <div class="home-card" @click="goRouter('/order')">
          <div class="home-card-icon">
            <img src="@/assets/imgs/icon_home_order.png" alt="">
          </div>
          <div class="home-card-title">{{ i18n.order }}</div>
          <div>{{ i18n.order_text }}</div>
          <img class="home-card-link" src="@/assets/imgs/icon_link.png" alt="">
        </div>
      </div>
      <div class="home-nav">
        <div class="home-nav-item" @click="goRouter('/coupon')">
          <img src="@/assets/imgs/icon_coupons.png" alt="">
          <span>{{ i18n.promos }}</span>
        </div>
        <div class="home-nav-item" @click="goRouter('/payment_card')">
          <img src="@/assets/imgs/icon_payment.png" alt="">
          <span>{{ i18n.payment_methods }}</span>
        </div>
        <div class="home-nav-item" @click="goRouter('/help')">
          <img src="@/assets/imgs/icon_faq.png" alt="">
          <span>{{ i18n.faq }}</span>
        </div>
        <div class="home-nav-item" @click="goRouter('/help_center')">
          <img src="@/assets/imgs/icon_help.png" alt="">
          <span>{{ i18n.help }}</span>
        </div>
        <div class="home-nav-item" @click="goRouter('/about')">
          <img src="@/assets/imgs/icon_about.png" alt="">
          <span>{{ i18n.about_us }}</span>
        </div>
        <div class="home-nav-item" @click="goRouter('/setting')">
          <img src="@/assets/imgs/icon_setting.png" alt="">
          <span>{{ i18n.settings }}</span>
        </div>
      </div>
      <invite v-model="isInvite"></invite>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import Invite from "@/components/invite/invite"
import { QR_CODE } from "@/apis/cabinet.js"
export default {
  components: {
    Invite
  },
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  data() {
    return {
      isInvite: false,
      qrcode: ''
    }
  },
  methods: {
    goRouter(path) {
      this.$router.push(path)
    },
    onScan(qrcode) {
      this.$loading(true)
      this.$post(
        `${QR_CODE}?id=${qrcode}&usePriceUnit=true`,
        {},
        (resp) => {
          this.$loading(false)
          if (resp.zujieNum && resp.zujieNum > 0 && !resp.haveMifiBattery) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18n.vieworder,
              cancelText: this.i18n.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.$store.commit("cabinet", {
              qrcode: qrcode,
              ...resp
            })
            this.$router.push("/borrow")
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  },
  created() {
    this.qrcode = this.$route.query.qrcode
    if (this.qrcode && this.user) {
      this.onScan(this.qrcode)
    }
  }
}
</script>

<style lang="less">
.home-warp {
  min-height: 100vh;
  background: #F8F6FC;
  padding: 53px;
  .home-head {
    display: flex;
    align-items: center;
    .home-head-avatar {
      width: 102px;
      height: 102px;
      border-radius: 50%;
    }
    .home-head-body {
      flex: 1;
      color: #000;
      font-size: 28px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      padding-left: 12px;
      align-items: start;
      .home-head-edit {
        padding: 5px 22px;
        background: rgba(255, 202, 14, 0.2);
        color: #FFCA0E;
        border-radius: 10px;
        margin-top: 5px;
        font-size: 22px;
      }
    }
    .home-head-btn {
      width: 49px;
      height: 49px;
      padding: 22px;
      border-radius: 26px;
      background: #FFCA0E;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .home-search {
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #E3E3E3;
    background: #fff;
    height: 93px;
    padding: 0 42px;
    border-radius: 24px;
    margin: 20px 0 46px;
    img {
      width: 35px;
      height: 35px;
      display: block;
      margin-right: 30px;
    }
  }
  .home-invite {
    position: relative;
    .home-invite-bg {
      width: 100%;
    }
    .home-invite-body {
      position: absolute;
      top: 40px;
      left: 33px;
      right: 230px;
      font-size: 24px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: start;
      .home-invite-btn {
        margin-top: 20px;
        padding: 9px 18px;
        background: #fff;
        border-radius: 16px;
        font-size: 22px;
        color: #FFCA0E;
        display: flex;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
          display: block;
          margin-left: 30px;
        }
      }
    }
  }
  .home-cards {
    padding: 28px 0;
    display: flex;
    .home-card {
      flex: 1;
      height: 225px;
      padding: 35px 0 0 28px;
      position: relative;
      background: #fff;
      border-radius: 28px;
      color: rgba(0, 0, 0, 0.6);
      font-size: 24px;
      .home-card-icon {
        width: 53px;
        height: 53px;
        background: #FFCA0E;
        padding: 11px 12px;
        border-radius: 14px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .home-card-title {
        color: #000;
        font-weight: bold;
        font-size: 28px;
        padding: 33px 0 5px;
      }
      .home-card-link {
        position: absolute;
        top: 33px;
        right: 23px;
        width: 72px;
        height: 72px;
      }
    }
    .home-card+.home-card {
      margin-left: 28px;
    }
  }
  .home-nav {
    margin-bottom: 53px;
    padding: 12px 10px;
    background: #fff;
    border-radius: 28px;
    .home-nav-item {
      padding: 23px;
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #000;
      font-weight: 500;
      img {
        width: 50px;
        height: 50px;
        display: block;
        margin-right: 23px;
      }
    }
  }
}
</style>
